import { render, staticRenderFns } from "./PageSize.vue?vue&type=template&id=318deae7&"
import script from "./PageSize.vue?vue&type=script&lang=ts&"
export * from "./PageSize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseSelect: require('/home/vsts/work/1/a/NuxtApp/components/base/Select.vue').default})
